<div class="card card-{{ cardValue }}" [class.card-rotated]="rotated" [class.card-compact]="compact"></div>
